import { Divider, Grid, Paper, Typography } from '@mui/material';
import './AdminAppControlKillSwitch.scss';
import { IOSSwitch as SDOKillSwitch } from '../../components/AdminAppControls/IOSSwitch';
import { useAdminAppControl } from '../../providers/AdminAppControlProvider';
import Loader from '../Loader/Loader';

const AdminAppControlKillSwitch: React.FC = () => {
  const { featureState, setFeatureState, isLoading } = useAdminAppControl();

  const handleSwitchChange = async (
    moduleId: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    await setFeatureState(moduleId, event.target.checked);
  };

  return (
    <Grid>
      {isLoading && (
        <Grid className="loader-overlay">
          <Loader />
        </Grid>
      )}
      <Grid className="admin-control-admin-header__container">
        <Grid className="admin-control-admin-header__title">
          <h1>Application Controls</h1>
        </Grid>
      </Grid>
      <Paper className="app-control-admin-body-container__paper">
        <Grid className="app-control-admin-kill-switch-container__inner">
          <Typography
            variant="h5"
            className="app-control-admin-kill-swtich__title"
          >
            Kill Switches
          </Typography>
          {featureState
            .filter((item) => item.isDisplay)
            .map((item) => (
              <Grid
                className="app-control-admin__switch-section"
                key={item.moduleId}
              >
                <Divider />
                <Grid className="app-control-admin__switch-row">
                  <Typography
                    variant="body1"
                    className="app-control-admin__switch-label"
                  >
                    {item.moduleName + ' Kill Switch'}
                  </Typography>
                  <SDOKillSwitch
                    sx={{ alignSelf: 'center' }}
                    checked={item.isEnabled}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                      handleSwitchChange(item.moduleId, event)
                    }
                    disabled={isLoading}
                  />
                </Grid>
                <Divider />
              </Grid>
            ))}
        </Grid>
      </Paper>
    </Grid>
  );
};

export default AdminAppControlKillSwitch;
